module.exports = __webpack_public_path__ + "static/media/grid.1db1d032.svg";